import { render, staticRenderFns } from "./FlightInfoArrival.vue?vue&type=template&id=8e99cc38"
import script from "./FlightInfoArrival.vue?vue&type=script&lang=js"
export * from "./FlightInfoArrival.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports